import React, { Component } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';
import { GoHistory, GoGear, GoCalendar } from 'react-icons/go';

export default class SchedulerTabs extends Component {
  handleTabSelect(tabSection) {
    const orgId = this.props.match.params.orgId;
    const blobId = this.props.match.params.blobId;

    var pagePath = `/${orgId}/${blobId}/${tabSection}`;
    this.props.history.push(pagePath);
  }

  render() {
    let activeKey = this.props.section;
    if (!activeKey || activeKey === "default") {
      activeKey = "schedules";
    }

    return (
      <>
        <Container className="blob-header-row main-tabs">
          <Tabs defaultActiveKey="schedules" activeKey={activeKey} onSelect={(key) => this.handleTabSelect(key)}>
            <Tab eventKey="schedules" title={<><GoCalendar/> Schedules</>}></Tab>
            <Tab eventKey="revisions" title={<><GoHistory/> Revisions</>}></Tab>
            {(this.props.blob && this.props.app.api.isBlobSettingsAccessible(this.props.blob)) &&
              <Tab eventKey="settings" title={<><GoGear/> Settings</>}></Tab>
            }
          </Tabs>
        </Container>
      </>
    );
  }
}
